import { FormField, Input, SpaceBetween } from "@cloudscape-design/components";
import { useState } from "react";
import { HexColorInput, HexColorPicker } from "react-colorful";
import { QRCode } from "react-qrcode-logo";
import UploadImage from "../components/UploadImage";

const QR = () => {
  const [value, setValue] = useState<string>(
    "https://shop.horriblemeadery.com"
  );
  const [bgColor, setBgColor] = useState<string>("#ffffff");
  const [fgColor, setFgColor] = useState<string>("#000000");

  const [image, setImage] = useState<string>();
  const [sizeImgW, setSizeImgW] = useState<string>("200");
  const [sizeImgH, setSizeImgH] = useState<string>("200");

  return (
    <SpaceBetween size="l">
      <SpaceBetween key="inputs" size="l">
        <FormField key="value" label="QR value">
          <Input
            value={value}
            onChange={({ detail }) => setValue(detail.value)}
          />
        </FormField>
        <SpaceBetween key="colors" direction="horizontal" size="m">
          <FormField key="bg" label="Background color">
            <SpaceBetween key="bg-controls" direction="horizontal" size="m">
              <HexColorPicker
                key="bg-picker"
                color={bgColor}
                onChange={setBgColor}
              />
              <HexColorInput
                key="bg-input"
                color={bgColor}
                onChange={setBgColor}
                prefixed
                style={{ width: 140 }}
              />
            </SpaceBetween>
          </FormField>
          <FormField key="fg" label="Foreground color">
            <SpaceBetween key="fg-controls" direction="horizontal" size="m">
              <HexColorPicker
                key="fg-picker"
                color={fgColor}
                onChange={setFgColor}
              />
              <HexColorInput
                key="fg-input"
                color={fgColor}
                onChange={setFgColor}
                prefixed
                style={{ width: 140 }}
              />
            </SpaceBetween>
          </FormField>
        </SpaceBetween>
        <SpaceBetween key="image" size="m" direction="horizontal">
          <UploadImage
            key="upload"
            title="QR image"
            fileName="qr-img"
            filePath={"NA"}
            noUpload
            setLocal={setImage}
          />
          <SpaceBetween key="dimensions" size="m" direction="vertical">
            <FormField key="width" label="Width">
              <Input
                value={sizeImgW}
                onChange={({ detail }) => setSizeImgW(detail.value)}
              />
            </FormField>
            <FormField key="height" label="Height">
              <Input
                value={sizeImgH}
                onChange={({ detail }) => setSizeImgH(detail.value)}
              />
            </FormField>
          </SpaceBetween>
        </SpaceBetween>
      </SpaceBetween>
      <QRCode
        key="qr"
        value={value}
        bgColor={bgColor}
        fgColor={fgColor}
        logoImage={image}
        logoWidth={parseInt(sizeImgW)}
        logoHeight={parseInt(sizeImgH)}
        size={400}
      />
    </SpaceBetween>
  );
};

export default QR;
